import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../public/GT-Planar-VF.woff2%22,%22weight%22:%22100%20900%22,%22style%22:%22normal%22,%22variable%22:%22--font-gt-planar%22,%22preload%22:true}],%22variableName%22:%22GTPlanar%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'GTPlanar', 'GTPlanar Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
